class LogConsoleOut {
  Save(msg) {
    console.log(msg);
  }
}

export default LogConsoleOut;
